var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9916 15.4778C31.7232 7.07163 24.9281 0.276844 16.5222 0.008395C11.9482 -0.136725 7.66901 1.60426 4.50648 4.86945C1.46616 8.0084 -0.13128 12.1466 0.00844847 16.5222C0.276673 24.9281 7.07169 31.7231 15.4776 31.9913C15.6526 31.9969 15.826 31.9996 15.9999 31.9996C20.3701 31.9996 24.4519 30.2703 27.4933 27.1303C30.5337 23.9915 32.1313 19.8532 31.9916 15.4778ZM25.073 24.7861C22.672 27.2651 19.4498 28.6302 15.9999 28.6302C15.862 28.6302 15.7241 28.628 15.585 28.6237C8.95083 28.4119 3.58814 23.0492 3.37608 16.4148C3.26578 12.9593 4.5267 9.69165 6.92679 7.21383C9.32778 4.73489 12.5501 3.36973 15.9999 3.36973C16.1378 3.36973 16.2758 3.37198 16.4148 3.37625C23.049 3.58809 28.4117 8.95077 28.6237 15.5852C28.734 19.0406 27.4729 22.3083 25.073 24.7861Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2474 15.0698L14.1523 9.98249C13.3955 9.43975 12.3419 9.98069 12.3419 10.9121V21.0868C12.3419 22.0182 13.3955 22.5592 14.1523 22.0164L21.2472 16.9289C21.8839 16.4727 21.8839 15.5262 21.2474 15.0698Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.b33aad0390160b1d01edba3acebf9d02.svg";
export { ForwardRef as ReactComponent };